import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireInputDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    concentric
} from "../../../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    container: {
        minWidth: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    borders,
    inset
}: QuestionnaireInputDynamicStyleType) => {
    const styles = {
        control: {
            ...getCornerStyle({
                radius: concentric({
                    inset: inset + borders.line,
                    outer: radiuses.surface,
                    role: radiuses.form
                }),
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
